import { FC, useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { generateOneLinkUrl } from '@cian/appsflyer-onelink';

import { Content } from 'shared/components/Content';
import { selectPlatform } from 'shared/selectors/platform';

import { MotivationContainer } from '../MotivationContainer';
import { AdvantagesContainer } from '../AdvantagesContainer';
import { trackButtonClick } from './tracking';
import { MOBILE_BANNER_TITLE, defaultUrl } from './constants';

export const ContentContainer: FC = () => {
  const platform = useSelector(selectPlatform);

  const [mobileBannerDownloadUrl, setMobileBannerDownloadUrl] = useState<string | null>(defaultUrl);

  useEffect(() => {
    setMobileBannerDownloadUrl(generateOneLinkUrl(mobileBannerDownloadUrl, 'mobile_site', MOBILE_BANNER_TITLE));
  }, []);

  const handleClick = useCallback((buttonName: string) => trackButtonClick(platform, buttonName), [platform]);

  return (
    <Content
      motivationTop={<MotivationContainer onClick={handleClick} url={mobileBannerDownloadUrl || defaultUrl} />}
      advantages={<AdvantagesContainer onClick={handleClick} url={mobileBannerDownloadUrl || defaultUrl} />}
      motivationBottom={
        <MotivationContainer onClick={handleClick} url={mobileBannerDownloadUrl || defaultUrl} isBottom />
      }
    />
  );
};
